import { useContext } from 'react'
import PropTypes from 'prop-types'
import {
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  InputBase
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import styled from '@emotion/styled'
import { Box } from 'rebass'
import { DataContext } from '../../contexts/dataContext'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import { lang } from '../../utils/lang'

const YearBox = styled(Box)`
  height: 1.5rem;
  display: ${(props) => (props.intro === 'closed' ? 'block' : 'none')};
  ${Mq.xs} {
    position: absolute;
    right: 3rem;
    bottom: 3rem;
    z-index: 1;
    display: ${(props) => (props.intro === 'closed' ? 'block' : 'none')};
  }
`
const StyledSelect = styled(Select)`
  border-radius: 500px;
  background-color: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.brightBlue};
  padding: 0 0.5rem;
  font-size: ${(props) => (props.ui === 'en' ? '0.7rem' : '.85rem')};
  text-transform: none;
  height: 1.5rem;
  padding-top: 0.1rem;
  display: flex;
  width: 50%;
  max-width: 50%;
  justify-content: space-evenly;
  .MuiSelect-icon {
    color: ${(props) => props.theme.colors.brightBlue};
    right: ${(props) => (props.ui === 'en' ? '0.25rem' : 'unset')};
    left: ${(props) => (props.ui === 'en' ? 'unset' : '0.25rem')};
  }
  .MuiSelect-select {
    padding: ${(props) =>
      props.ui === 'en' ? '0 1.5rem 0 0' : '0 0 0 1.5rem'};
  }
  .MuiMenuItem-root {
    text-transform: none;
  }
  ${Mq.xs} {
    width: unset;
    .MuiSelect-icon {
      left: ${(props) => (props.ui === 'en' ? 'unset' : '0.25rem')};
    }
  }
`
const StyledFormControl = styled(FormControl)`
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  height: 100%;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 500px;
  width: 100%;
  .MuiInputLabel-formControl {
    color: ${(props) => props.theme.colors.black};
    position: relative;
    font-family: ${(props) => props.theme.fonts.condensed};
    font-size: 1rem;
    text-transform: uppercase;
    transform-origin: unset;
    padding-bottom: 0.1rem;
  }
  ${Mq.xs} {
    width: 14rem;
    max-width: 14rem;
  }
`
const Divider = styled.div`
  border-left: 1px solid ${(props) => props.theme.colors.steelBlue};
  height: 100%;
`
const menuProps = {
  classes: {
    paper: 'year-selector-paper',
    list: 'year-selector-list'
  }
}
const YearSelector = ({ selectedYear, setSelectedYear }) => {
  const { intro, ui } = useContext(DataContext)

  const dir = ui === 'en' ? 'ltr' : 'rtl'
  const yearArray = Array.from(Array(new Date().getFullYear() - 1978), (_, i) =>
    (i + 1979).toString()
  )

  const handleChange = (e) => {
    const value = e.target.value
    //'all' has just been selected -- need to take out others
    if (value[value.length - 1] === 'All Years') {
      setSelectedYear(['All Years'])
      return
      //something else has been selected and we need to take out 'all' which is always the first one in the array
    } else if (value[0] === 'All Years') value.shift()

    setSelectedYear(value)
  }

  return (
    <YearBox intro={intro}>
      <StyledFormControl dir={dir}>
        <InputLabel id={'year'}>{lang[ui]['SelectYear']}</InputLabel>
        <Divider />
        <StyledSelect
          labelId={'year'}
          value={selectedYear}
          onChange={handleChange}
          multiple
          displayEmpty
          input={<InputBase />}
          renderValue={(selectedYear) => {
            if (selectedYear[0] === 'All Years') {
              return <MenuItem dir={dir}>{lang[ui]['AllYears']}</MenuItem>
            }
            return selectedYear.join(', ')
          }}
          IconComponent={ExpandMoreIcon}
          MenuProps={menuProps}
          ui={ui}
        >
          <MenuItem value={'All Years'} dir={dir}>
            {lang[ui]['AllYears']}
          </MenuItem>
          {yearArray.map((year) => (
            <MenuItem key={year} value={year} dir={dir}>
              {year}
            </MenuItem>
          ))}
        </StyledSelect>
      </StyledFormControl>
    </YearBox>
  )
}
export default YearSelector

YearSelector.propTypes = {
  selectedYear: PropTypes.array.isRequired,
  setSelectedYear: PropTypes.func.isRequired
}
